import { MapPin, Clock, Instagram } from "lucide-react";
import { Reveal, Horizon } from "../components/Reveal";
import { IMG } from "../data/images";
import { INFO } from "../data/info";
import { useLang } from "../i18n";

export const Visit = () => {
  const { t } = useLang();

  return (
    <section id="visitanos" data-testid="visit-section" className="bg-[#F5EDE3] px-6 py-24 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-16 lg:grid-cols-[0.85fr_1.15fr] lg:gap-24">
          <div>
            <Reveal>
              <p className="label text-[#8A6A4F]">{t.visit.label}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-[16ch] font-serif text-4xl font-light leading-[1.06] text-[#2B1E16] sm:text-5xl lg:text-6xl">
                {t.visit.title}
              </h2>
            </Reveal>

            <div className="mt-12 max-w-sm">
              <Horizon />
            </div>

            <Reveal delay={0.2}>
              <div className="v1-visit-details mt-10 space-y-9">
                <div className="flex gap-5">
                  <MapPin className="mt-1 shrink-0 text-[#8A6A4F]" size={18} strokeWidth={1.5} />
                  <div>
                    <p className="label text-[#2B1E16]/45">{t.visit.addressLabel}</p>
                    <p className="mt-2 font-serif text-xl text-[#2B1E16]">{INFO.address}</p>
                    <p className="font-serif text-xl text-[#2B1E16]">{INFO.city}</p>
                  </div>
                </div>
                <div className="flex gap-5">
                  <Clock className="mt-1 shrink-0 text-[#8A6A4F]" size={18} strokeWidth={1.5} />
                  <div>
                    <p className="label text-[#2B1E16]/45">{t.visit.hoursLabel}</p>
                    <p className="mt-2 font-serif text-xl text-[#2B1E16]">{t.visit.hoursEveryDay}</p>
                    <p className="font-serif text-xl text-[#2B1E16]" dir="ltr">9:00 – 18:00</p>
                  </div>
                </div>
                <div className="flex gap-5">
                  <Instagram className="mt-1 shrink-0 text-[#8A6A4F]" size={18} strokeWidth={1.5} />
                  <div>
                    <p className="label text-[#2B1E16]/45">{t.visit.instagramLabel}</p>
                    <a
                      data-testid="visit-instagram-link"
                      href={INFO.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      dir="ltr"
                      className="mt-2 inline-block font-serif text-xl text-[#2B1E16] underline decoration-[#D9B98A] decoration-1 underline-offset-4 transition-colors hover:text-[#8A6A4F]"
                    >
                      @deseos.brunch.coffee
                    </a>
                  </div>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.3}>
              <a
                data-testid="visit-directions-btn"
                href={INFO.directions}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-dark mt-12 inline-block"
              >
                {t.visit.mapsBtn}
              </a>
            </Reveal>
          </div>

          <div className="space-y-3">
            <Reveal delay={0.15}>
              <div className="v1-map map-warm h-[300px] overflow-hidden bg-[#2B1E16] sm:h-[400px]">
                <iframe
                  title={t.visit.mapTitle}
                  data-testid="visit-map"
                  src={INFO.mapEmbed}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="v1-visit-photo group overflow-hidden bg-[#2B1E16]/10">
                <img
                  src={IMG.terrace}
                  alt={t.visit.altTerrace}
                  data-placeholder-name="entrada.webp"
                  loading="lazy"
                  className="h-[220px] w-full object-cover transition-transform duration-[2200ms] ease-out group-hover:scale-105 sm:h-[280px]"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
